export default __webpack_public_path__ + "static/media/3060.b94020dc.jpg";